import { defineComponent as r, createBlock as c, openBlock as d, unref as n, mergeProps as o, withCtx as p, createElementVNode as e } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const f = /* @__PURE__ */ r({
  name: "IconReassuranceCreditCardFilled",
  __name: "IconReassuranceCreditCardFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(l) {
    const t = l;
    return (m, a) => (d(), c(n(i), o(t, { "view-box": "0 0 48 48" }), {
      default: p(() => [...a[0] || (a[0] = [
        e("g", {
          "fill-rule": "evenodd",
          "clip-path": "url(#ee55a531-e04c-4cf3-b5ae-abdb114d61b1a)",
          "clip-rule": "evenodd"
        }, [
          e("path", { d: "m18.83 7.32 16.08 3a3.419 3.419 0 0 1 2.24 1.47 3.48 3.48 0 0 1 .56 2.62l-4.38 23.42a3.51 3.51 0 0 1-4.09 2.8l-16.08-3a3.51 3.51 0 0 1-2.79-4.09l4.38-23.43a3.49 3.49 0 0 1 4.08-2.79m-4.283 26.821a.51.51 0 0 0 .173-.291l1.31-6.98a.5.5 0 0 0-.4-.59.51.51 0 0 0-.58.4l-1.31 7a.488.488 0 0 0 .4.58h.09a.51.51 0 0 0 .317-.119m3.004.615a.49.49 0 0 0 .169-.296l.49-2.48a.508.508 0 0 0-1-.18l-.47 2.48a.5.5 0 0 0 .4.59h.09a.49.49 0 0 0 .321-.114M29.11 18.28c-.41-.24-1.16.29-1.66 1.18l-.05-.05c-.5.89-.51 1.81-.1 2.05.41.24 1.14-.32 1.65-1.18.51-.86.57-1.76.16-2m-3.51-2.29c-.67-.46-1.92.2-2.79 1.47l-.05-.07c-.86 1.27-1.03 2.65-.36 3.13s1.97-.13 2.84-1.4c.87-1.27 1.03-2.67.36-3.13m.39 10.34a9 9 0 0 0 3.28 0l-.05-.07a.2.2 0 0 0 .14-.2.19.19 0 0 0-.18-.21 15.156 15.156 0 0 1-3-.61A12.41 12.41 0 0 1 23.46 24a11.168 11.168 0 0 1-2.29-1.87 21.715 21.715 0 0 1-2-2.36.25.25 0 0 0-.27-.09.25.25 0 0 0-.16.32 8.81 8.81 0 0 0 4.13 5.18 9.328 9.328 0 0 0 3.12 1.15" }),
          e("path", { d: "M10.666 4.045a24 24 0 1 1 26.668 39.91 24 24 0 0 1-26.668-39.91M34.31 38l4.38-23.41-.01-.01a4.5 4.5 0 0 0-3.6-5.25L19 6.33a4.5 4.5 0 0 0-5.24 3.6L9.4 33.36a4.52 4.52 0 0 0 3.6 5.25l16.06 2.99a4.758 4.758 0 0 0 .84.07A4.51 4.51 0 0 0 34.31 38" })
        ], -1),
        e("defs", null, [
          e("clipPath", { id: "ee55a531-e04c-4cf3-b5ae-abdb114d61b1a" }, [
            e("path", { d: "M0 0h48v48H0z" })
          ])
        ], -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
